import { connect } from 'react-redux';
import { formValueSelector } from 'redux-form';
import { ADD_FORM_NAME } from 'presentations/constants';
import AddStepIntro from 'presentations/components/add_step_intro';

const mapStateToProps = (state) => {
  const selector = formValueSelector(ADD_FORM_NAME);
  /* only the form values that will be used in the component */
  const values = selector(state, 'use_standard_colors', 'custom_primary_color', 'logo', 'purpose');

  return {
    values
  };
}

export default connect(mapStateToProps)(AddStepIntro);



// WEBPACK FOOTER //
// ./presentations/containers/add_step_intro.js